export enum ContestMemberPermission {
  ADMIN = 'ADMIN',
  EDIT = 'EDIT',
  READ = 'READ'
}
